import React from 'react'

export default function Right (props) {
  return (
    <svg {...props} viewBox="0 0 1024 1024" p-id="3280" width={ props.width || 200 } height={ props.height || 200 }>
      <path d="M463.466 0.128c15.73 0 31.397 6.01 43.482 17.968l450.358 450.358c24.043 23.98 24.043 62.793 0 86.772l-450.358 450.486c-23.915 23.979-62.793 23.979-86.836 0-23.979-24.043-23.979-62.857 0-86.836l406.94-406.94L420.048 105.06c-23.979-24.107-23.979-62.92 0-86.9C432.134 6.14 447.736 0.128 463.466 0.128z" p-id="3281" fill="#F5004D" />
    </svg>
  )
}